import { USE_ALPHA_FEATURES_ABILITY } from 'app/constants/enums/Ability';

/**
 * Determines whether or not the content is restricted. Essentially,
 * if the user is not authenticated, content is restricted. If
 * `allowedAbilities` is specified, then there has to be a match
 * against any of the user abilities (`currentAbilities`).
 *
 * @param {Array[ABILITIES]|List[ABILITIES]} allowedAbilities
 * @param {Boolean} isAuthenticated
 * @param {Array[ABILITIES]|List[ABILITIES]} currentAbilities
 * @param {Boolean} alphaOnly                 makes sure the user has the alpha ability
 * @returns {Boolean}
 */
export const isRestricted = (
  allowedAbilities,
  isAuthenticated = false,
  currentAbilities = [],
  alphaOnly = false,
) => {
  if (!isAuthenticated) {
    return true;
  } else if (alphaOnly && !currentAbilities.includes(USE_ALPHA_FEATURES_ABILITY)) {
    return true;
  } else if (typeof allowedAbilities !== 'undefined') {
    return !allowedAbilities.some(ability => currentAbilities.includes(ability));
  } else {
    return false;
  }
};
